export default __webpack_public_path__ + "static/media/b10.20c5fcbf.jpg";